import React from 'react'

import {
  useMap,
  useMapsLibrary,
  // eslint-disable-next-line
} from '@vis.gl/react-google-maps/dist/index.umd.js'
import {
  setDatasetLayer,
  setMarkerInfo,
  updateBottomSheet,
} from '../../redux/myMapsSlice'
import { MOBILEPARKINGINFOWINDOW } from '../../../../utils/constants'
import {
  removePolylineStyle,
  setPolylineStyle,
} from '../../../../utils/helpers'

function PolylineFromDataset({
  showParkingLots,
  dispatch,
  parkingLotData,
  isMobile,
}) {
  const map = useMap()
  const infowWindowInstance = useMapsLibrary('maps') // load 'core' library to get access to InfoWindow
  const datasetLayer = map.getDatasetFeatureLayer(
    'd744edd6-00be-46d3-bf7b-3efc87c9bf40',
  )

  React.useEffect(() => {
    if (datasetLayer) {
      dispatch(setDatasetLayer(datasetLayer))
    }
  }, [datasetLayer])

  React.useEffect(() => {
    if (!map || !infowWindowInstance) return

    datasetLayer.style = setPolylineStyle

    datasetLayer.addListener('click', (event) => {
      //   const { latLng } = event
      //   const featureObj = event.features[0]

      // track polylines clicked so that we can update their color
      datasetLayer.style = ({ feature }) => {
        const isActive =
          feature.datasetAttributes?.Parking_ID ===
          event.features[0].datasetAttributes.Parking_ID
        // use the "Parking_ID" to "Map ID" to find the appropriate lot clicked
        let parkingLotClicked = parkingLotData.find(
          (lotItem) =>
            lotItem['Map ID']?.toString() ===
            event.features[0].datasetAttributes?.Parking_ID,
        )
        if (!parkingLotClicked) {
          parkingLotClicked = {
            Lot: feature.datasetAttributes?.Lot_Name,
            'Address 1': feature.datasetAttributes?.Address,
            'City Code': feature.datasetAttributes?.Campus,
          }
        }
        if (isActive) {
          dispatch(setMarkerInfo({ ...parkingLotClicked, isActive }))
        }
        if (isMobile) {
          dispatch(updateBottomSheet(MOBILEPARKINGINFOWINDOW))
        }
        return {
          strokeColor: isActive ? '#7DBFD6' : '#007FAC',
          fillColor: isActive ? '#007FAC' : '#7DBFD6',
          strokeOpacity: 1.0,
          strokeWeight: 3,
          fillOpacity: isActive ? 1 : 0.5,
        }
      }
    })
  }, [map, infowWindowInstance])

  React.useEffect(() => {
    if (!map) return

    if (showParkingLots === false) {
      datasetLayer.style = removePolylineStyle
    } else {
      datasetLayer.style = setPolylineStyle
    }
  }, [map, showParkingLots])

  return null
}

export default PolylineFromDataset
